import { useEffect, useRef, useState } from 'react'

export const useSectionMapVisibility = () => {
    const ref = useRef<HTMLDivElement>(null)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (!ref.current) return undefined
        if (typeof IntersectionObserver === 'undefined') {
            setIsVisible(true)
            return undefined
        }

        const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return
            setIsVisible(true)
            observer.disconnect()
        })
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])

    return { ref, isVisible }
}
